import "./App.css";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Products } from "./components/Products";
import { Reviews } from "./components/Reviews";
import { VisitUs } from "./components/VisitUs";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Products />
        <About />
        <Reviews />
        <VisitUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
